// extracted by mini-css-extract-plugin
module.exports = {"inputError":"TextEditor_inputError__3zaDk"};